import { DEV_API_TARGETS, getDevApiTarget, setDevApiTarget, type DevApiTarget } from "@/config.ts"

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select.tsx"
import { SidebarMenu, SidebarMenuItem } from "./ui/sidebar.tsx"

// Dev-only -- import.meta.env.DEV is eliminated at build time in
// production, so this whole component (and its localStorage/reload logic)
// never ships. Lets a dev switch which backend every API call in the app
// targets without hand-editing .env.local and restarting the dev server.
export default function DevApiTargetSwitcher() {
  if (!import.meta.env.DEV) return null

  const current = getDevApiTarget()

  return (
    <SidebarMenu>
      <SidebarMenuItem className="px-2 pb-2">
        <Select
          value={current ?? "default"}
          onValueChange={(value) =>
            setDevApiTarget(value === "default" ? null : (value as DevApiTarget))
          }
        >
          <SelectTrigger size="sm" className="w-full">
            <SelectValue placeholder="API target" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="default">Default (.env)</SelectItem>
            {Object.entries(DEV_API_TARGETS).map(([key, url]) => (
              <SelectItem key={key} value={key}>
                {key === "local" ? "Local AppHost" : "Deployed test"} — {url}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
